import { getApiUrl, formatApiFetchError } from './apiConfig';
import { filterStudentsForViewer } from './studentVisibility';

export function isStudentVisible(row) {
  if (!row || typeof row !== 'object') return false;
  if (row.visible === false) return false;
  return true;
}

/**
 * Load students for picker UIs. Tries ?visible=true then full /api/users with client-side filter.
 * @param {{ excludeUserId?: number, requester?: import('./sessionUser').StudentUser|null }} [opts]
 */
export async function fetchVisibleStudents({ excludeUserId, requester } = {}) {
  const requesterId = requester?.id;
  const requesterQuery =
    requesterId != null ? `&requester_id=${encodeURIComponent(String(requesterId))}` : '';
  const urls = [
    `${getApiUrl()}/api/users?visible=true${requesterQuery}`,
    `${getApiUrl()}/api/users${requesterQuery ? `?${requesterQuery.slice(1)}` : ''}`,
  ];
  let lastError = null;

  for (const url of urls) {
    try {
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
        },
      });
      if (!res.ok) {
        lastError = new Error(`HTTP ${res.status}`);
        continue;
      }
      const data = await res.json();
      if (!Array.isArray(data)) {
        lastError = new Error('Invalid students response');
        continue;
      }

      let list = data.filter(isStudentVisible);
      list = filterStudentsForViewer(requester, list);
      list.sort((a, b) => {
        const ra = a.student_grade_rank ?? 999;
        const rb = b.student_grade_rank ?? 999;
        if (ra !== rb) return ra - rb;
        return String(a.username || '').localeCompare(String(b.username || ''));
      });

      if (excludeUserId != null && Number.isFinite(Number(excludeUserId))) {
        const selfId = Number(excludeUserId);
        const others = list.filter((s) => Number(s.id) !== selfId);
        if (others.length > 0) {
          list = others;
        }
      }

      return { students: list, error: null };
    } catch (e) {
      lastError = e;
    }
  }

  return {
    students: [],
    error: formatApiFetchError(lastError || new Error('Could not load students')),
  };
}
